export const RELEASE_LINE = {
  angular: '9.1.x',
  packageVersion: '9.0.0',
  coreVersion: '0.1.1',
  runtimeTarget: 'Angular 9 + Angular CLI',
  docsPath: '/angular-9/'
};
